export default __webpack_public_path__ + "icons/android-chrome-512x512-4a44c887af2e26728f3425a5deb3a66b.png";